/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  TrainWithMeModulesClientsDtosRequestsSetBrandColorRequest,
  TrainWithMeModulesClientsDtosResponsesBrandColorResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const deleteMeBrandColor = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesBrandColorResponse>(
      {url: `/me/brand-color`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteMeBrandColorMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMeBrandColor>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMeBrandColor>>, TError,void, TContext> => {

const mutationKey = ['deleteMeBrandColor'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMeBrandColor>>, void> = () => {


          return  deleteMeBrandColor(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMeBrandColorMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMeBrandColor>>>

    export type DeleteMeBrandColorMutationError = ErrorType<unknown>

    export const useDeleteMeBrandColor = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMeBrandColor>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMeBrandColor>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteMeBrandColorMutationOptions(options), queryClient);
    }
    export const getMeBrandColor = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesBrandColorResponse>(
      {url: `/me/brand-color`, method: 'GET', signal
    },
      options);
    }




export const getGetMeBrandColorQueryKey = () => {
    return [
    `/me/brand-color`
    ] as const;
    }


export const getGetMeBrandColorQueryOptions = <TData = Awaited<ReturnType<typeof getMeBrandColor>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeBrandColor>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeBrandColorQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeBrandColor>>> = ({ signal }) => getMeBrandColor(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeBrandColor>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeBrandColorQueryResult = NonNullable<Awaited<ReturnType<typeof getMeBrandColor>>>
export type GetMeBrandColorQueryError = ErrorType<unknown>


export function useGetMeBrandColor<TData = Awaited<ReturnType<typeof getMeBrandColor>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeBrandColor>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeBrandColor>>,
          TError,
          Awaited<ReturnType<typeof getMeBrandColor>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeBrandColor<TData = Awaited<ReturnType<typeof getMeBrandColor>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeBrandColor>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeBrandColor>>,
          TError,
          Awaited<ReturnType<typeof getMeBrandColor>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeBrandColor<TData = Awaited<ReturnType<typeof getMeBrandColor>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeBrandColor>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMeBrandColor<TData = Awaited<ReturnType<typeof getMeBrandColor>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeBrandColor>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeBrandColorQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putMeBrandColor = (
    trainWithMeModulesClientsDtosRequestsSetBrandColorRequest?: BodyType<TrainWithMeModulesClientsDtosRequestsSetBrandColorRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesBrandColorResponse>(
      {url: `/me/brand-color`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesClientsDtosRequestsSetBrandColorRequest, signal
    },
      options);
    }




export const getPutMeBrandColorMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMeBrandColor>>, TError,{data?: BodyType<TrainWithMeModulesClientsDtosRequestsSetBrandColorRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putMeBrandColor>>, TError,{data?: BodyType<TrainWithMeModulesClientsDtosRequestsSetBrandColorRequest>}, TContext> => {

const mutationKey = ['putMeBrandColor'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMeBrandColor>>, {data?: BodyType<TrainWithMeModulesClientsDtosRequestsSetBrandColorRequest>}> = (props) => {
          const {data} = props ?? {};

          return  putMeBrandColor(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutMeBrandColorMutationResult = NonNullable<Awaited<ReturnType<typeof putMeBrandColor>>>
    export type PutMeBrandColorMutationBody = BodyType<TrainWithMeModulesClientsDtosRequestsSetBrandColorRequest> | undefined
    export type PutMeBrandColorMutationError = ErrorType<unknown>

    export const usePutMeBrandColor = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMeBrandColor>>, TError,{data?: BodyType<TrainWithMeModulesClientsDtosRequestsSetBrandColorRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putMeBrandColor>>,
        TError,
        {data?: BodyType<TrainWithMeModulesClientsDtosRequestsSetBrandColorRequest>},
        TContext
      > => {
      return useMutation(getPutMeBrandColorMutationOptions(options), queryClient);
    }
